export interface Sponsor {
  /** Stable React key. */
  key: string;
  /** Display name shown under the avatar. */
  name: string;
  /** GitHub username — used for the avatar (`https://github.com/<github>.png`). */
  github: string;
  /** Optional override for the profile link (defaults to `https://github.com/<github>`). */
  href?: string;
}

export const SPONSORS: Sponsor[] = [
  { key: "kastov", name: "kastov", github: "kastov" },
  { key: "guimazza", name: "guimazza", github: "guimazza" },
];

export const SPONSOR_URL = "https://github.com/sponsors/gfazioli";

export const DONATE_URL = "https://donate.stripe.com/fZu4gy4Tn3b1dgudGx0co00";
